import React from "react";

import { Formik, Form } from "formik";
import * as yup from "yup";

import domainsApi from "apis/domains";
import { Pane, Typography, Button } from "clearsense-ui/components";
import { Input, Textarea } from "clearsense-ui/components/formik";

const NewDomain = ({
  isCreateDomainOpen,
  setIsCreateDomainOpen,
  fetchDomainsData,
  isEdit,
  editedRecord,
}) => {
  const handleSubmit = async values => {
    const payload = {
      name: values.name,
      description: values.description,
    };
    try {
      isEdit
        ? await domainsApi.edit(editedRecord.id, payload)
        : await domainsApi.create(payload);
    } catch (error) {
      logger.log(error);
    } finally {
      fetchDomainsData();
      setIsCreateDomainOpen(false);
    }
  };

  return (
    <Pane
      isOpen={isCreateDomainOpen}
      onClose={() => setIsCreateDomainOpen(false)}
    >
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          {isEdit ? "Edit Domain" : "Add New Domain"}
        </Typography>
      </Pane.Header>
      <Formik
        initialValues={
          isEdit
            ? {
                name: editedRecord.name,
                description: editedRecord.description,
              }
            : {
                name: "",
                description: "",
              }
        }
        validationSchema={yup.object({
          name: yup.string().required("Name is a required field."),
          description: yup.string(),
        })}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {() => (
          <Form>
            <Pane.Body>
              <div className="space-y-4 py-2">
                <Input
                  name="name"
                  label="Name"
                  placeholder="Name"
                  required
                  className="w-96"
                  data-cy="domain-name-text-field"
                />
                <Textarea
                  name="description"
                  label="Description"
                  placeholder="Description"
                  className="w-96"
                  data-cy="domain-description-text-area"
                />
              </div>
            </Pane.Body>
            <Pane.Footer className="items-center">
              <Button
                label="Save changes"
                size="medium"
                type="submit"
                data-cy="submit-domain-button"
              />
              <Button
                label="Cancel"
                style="text"
                size="medium"
                onClick={() => setIsCreateDomainOpen(false)}
              />
            </Pane.Footer>
          </Form>
        )}
      </Formik>
    </Pane>
  );
};

export default NewDomain;
